import { parseModuleRegistry } from '../lib/module-registry';
import type { ModuleRegistryConfig } from '../lib/module-registry';

/**
 * Module registry configuration.
 * Add new micro-frontend modules here — no other source files need to change.
 *
 * Fields per entry:
 *   id             – unique kebab-case identifier
 *   name           – display name shown in sidebar and dashboard tile
 *   description    – short description shown on the dashboard tile
 *   icon           – Lucide icon name (https://lucide.dev/icons)
 *   routePath      – must start with /modules/
 *   sourceUrl      – URL where the micro-frontend is hosted
 *   requiredRole   – minimum role required: "admin" | "user" | "read-only"
 *   embeddingMethod – "iframe" (embedded in shell) | "new-tab" (opens externally)
 */
const rawConfig: ModuleRegistryConfig = {
  version: '1.0',
  modules: [
      {
      id: 'conference-check-in-scanner',
      name: 'Event Check-In Scanner',
      description: 'Real-time camera-based membership card scanning and check-in logging for event registration.',
      icon: 'ScanLine',
      routePath: '/modules/conference-check-in-scanner',
      requiredRole: 'user',
      embeddingMethod: 'native',
    },
     {
      id: 'lodge-locator',
      name: 'Lodge Finder',
      description: 'Testing module w/ Lodge Locator',
      icon: 'Building',
      routePath: '/modules/lodge-locator',
      sourceUrl: 'https://lodge-finder.lab.webpile.com/',
      requiredRole: 'read-only',
      embeddingMethod: 'iframe',
      fullWidth: true,
    },
    // {
    //   id: 'inventory-mgmt',
    //   name: 'Inventory Management',
    //   description: 'Track stock levels, manage products, and process purchase orders.',
    //   icon: 'Package',
    //   routePath: '/modules/inventory-mgmt',
    //   sourceUrl: 'https://inventory.example.internal',
    //   requiredRole: 'admin',
    //   embeddingMethod: 'iframe',
    // },
    // {
    //   id: 'reports',
    //   name: 'Reports',
    //   description: 'View operational reports and export data for analysis.',
    //   icon: 'BarChart2',
    //   routePath: '/modules/reports',
    //   sourceUrl: 'https://reports.example.internal',
    //   requiredRole: 'admin',
    //   embeddingMethod: 'iframe',
    // },
  ],
};

/**
 * Parsed and validated module entries.
 * Invalid entries are excluded and a warning is logged for each one.
 * Import this wherever the registry is needed (sidebar, dashboard, router).
 */
export const moduleRegistry = parseModuleRegistry(rawConfig);
